
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.33 52.143h48.34M8.33 35.329l21.017-8.407m-16.813 6.766v18.455M26.195 12.21L56.67 31.126m-4.204-2.562v23.579m-6.305-27.518v-7.16c0-.58.47-1.051 1.051-1.051h2.102c.58 0 1.05.47 1.05 1.05v9.755m-3.152 24.924c.58 0 1.05-.47 1.05-1.051v-6.305c0-.58-.47-1.051-1.05-1.051h-12.61c-.58 0-1.051.47-1.051 1.05v6.306c0 .58.47 1.05 1.05 1.05m7.357-8.406v8.407m-6.303-21.017a3.152 3.152 0 106.305 0 3.152 3.152 0 00-6.305 0h0zM24.093 52.143c.58 0 1.051-.47 1.051-1.051v-8.407c0-.58-.47-1.05-1.05-1.05h-6.307c-.58 0-1.05.47-1.05 1.05v8.407c0 .58.47 1.05 1.05 1.05m11.56-37.929v37.93","stroke":"#D6DBEA","stroke-width":"2.102","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    